import { Item } from 'typings'
import {
  BuyAndWinBenefitVariant,
  ShippingApplyTo,
  ShippingKeys,
} from './buyAndWin'
import { RegularBenefitVariant } from './regular'

export type ShippingApplyToAll<Base> = Base & {
  [ShippingKeys.applyTo]: ShippingApplyTo.all
}

export type ShippingApplyToCheapest<Base> = Base & {
  [ShippingKeys.applyTo]: ShippingApplyTo.cheapest
}

export type ShippingApplyToSelected<Base> = Base & {
  [ShippingKeys.applyTo]: ShippingApplyTo.selected
  [ShippingKeys.selectedMethods]: Item[]
}

export type GenericShipping<Base> =
  | ShippingApplyToAll<Base>
  | ShippingApplyToCheapest<Base>
  | ShippingApplyToSelected<Base>

export type BuyAndWinFreeShipping = GenericShipping<{
  type: BuyAndWinBenefitVariant.FREE_SHIPPING
}>

export type RegularFreeShipping = GenericShipping<{
  type: RegularBenefitVariant.FreeShipping
}>
